import React from "react";
import general from "../../../../../../general";
import CustomCardBase from "./CustomCardBase";

// subType=3 交易（多一个价格行，通过 children 注入）
export default function TradeMessage({ msg }) {
  const { attach } = msg;
  return (
    <CustomCardBase
      tagColor="#FF5E00"
      tagText="交易"
      title="出售角色"
      gameInfo={attach?.game_info}
      desc={attach?.equipment_declare}
      onClick={() => general.history.push("/trade/detail?id=" + attach?.trade_id)}
    >
      <div className="imc-card-price">
        ￥{attach?.sell_price}
        <span className="imc-card-origin-price">￥{attach?.origin_price}</span>
      </div>
    </CustomCardBase>
  );
}
